import { KlevuLastClickedProducts } from "../../store/lastClickedProducts.js";
import { KlevuTypeOfRecord, KlevuTypeOfRequest, } from "../../models/index.js";
const defaultOptions = {
    id: "trendingCategoryProducts",
};
/**
 * Return trending recommendations
 *
 * @category RecommendationQuery
 * @param options
 * @param modifiers
 * @returns
 */
export function trendingCategoryProducts(categoryPath, options, ...modifiers) {
    const params = Object.assign(Object.assign({}, defaultOptions), options);
    const query = {
        id: params.id,
        typeOfRequest: KlevuTypeOfRequest.Trending,
        settings: {
            context: params.useLastVisitedProducts
                ? {
                    recentObjects: [
                        {
                            typeOfRecord: KlevuTypeOfRecord.Product,
                            records: KlevuLastClickedProducts.getLastClickedLatestsFirst().map((id) => ({ id })),
                        },
                    ],
                }
                : (params === null || params === void 0 ? void 0 : params.recent) && (params === null || params === void 0 ? void 0 : params.recentType)
                    ? {
                        recentObjects: [
                            {
                                typeOfRecord: params.recentType,
                                records: params.recent.map((id) => ({ id })),
                            },
                        ],
                    }
                    : undefined,
            query: {
                term: "*",
                categoryPath: categoryPath,
            },
        },
    };
    return {
        klevuFunctionId: "recommendation",
        queries: [query],
        modifiers,
    };
}
